import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/auth/Login.vue"
import Logout from "../components/auth/Logout.vue"
import Register from "../components/auth/Register.vue"
import PrivacyPolicy from "../components/PrivacyPolicy.vue"
import Status from '../components/events/Status.vue';

import Manage from "../components/events/Manage.vue"

Vue.use(Router)

export default new Router({
    routes: [
        // Home is bind to manage
        {
            path: "/",
            name: "Home",
            component: Manage
        },

        // Authentication
        {
            path: "/auth/login",
            name: "Login",
            component: Login
        },

        {
            path: "/auth/logout",
            name: "Logout",
            component: Logout
        },

        // Manage Events
        {
            path: "/manage",
            name: "Manage",
            component: Manage
        },
        {
            path: "/Triebguet_App_Privacy_Policy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy
        },

        {
            path: "/status",
            name: "Status",
            component: Status,
            meta: {
                simplePage: true,
            },
        },
    ]
});


// WEBPACK FOOTER //
// ./src/routing/router.ts